
<footer class="primary-dark-bg text-white">
  
  <!-- Main Footer Content -->
  <div class="container py-5">
    <div class="row g-4">
      
      <!-- Brand & Scripture Section -->
      <div class="col-lg-4 col-md-6">
        <div class="footer-section">
          <!-- Brand -->
          <div class="footer-brand mb-4">
            <img src="assets/img/logo_white_tb.png" 
                 alt="Intercessory Training Logo" 
                 height="auto" 
                 class="mb-3">
            <h4 class="fw-bold mb-0">{{ 'FOOTER.INTERCESSORY_PRAYER' | translate }}</h4>
          </div>
          
          <!-- Scripture Quote -->
          <div class="footer-scripture">
            <blockquote class="blockquote">
              <p class="mb-2 fst-italic">
                <i class="fa fa-quote-left me-2 text-light"></i>
                {{ 'FOOTER.BIBLE_VERSE_TEXT' | translate }}
                <i class="fa fa-quote-right ms-2 text-light"></i>
              </p>
              <footer class="blockquote-footer text-white-50 small">
                {{ 'FOOTER.BIBLE_VERSE_REFERENCE' | translate }}
              </footer>
            </blockquote>
          </div>
        </div>
      </div>

      <!-- Quick Links Section -->
      <div class="col-lg-2 col-md-6">
        <div class="footer-section">
          <h4 class="text-uppercase fw-bold mb-4 text-light">
            <i class="fa fa-link me-2"></i>
            {{ 'FOOTER.QUICK_LINKS' | translate }}
          </h4>
          <ul class="list-unstyled footer-links">
            <li class="mb-2">
              <a [routerLink]="['/']" class="footer-link">
                <i class="fa fa-home me-2"></i>
                {{ 'FOOTER.HOME' | translate }}
              </a>
            </li>
            <li class="mb-2">
              <a [routerLink]="['/learn-more']" class="footer-link">
                <i class="fa fa-info-circle me-2"></i>
                {{ 'FOOTER.ABOUT_TRAINING' | translate }}
              </a>
            </li>
            <li class="mb-2">
              <a [routerLink]="['/contact-us']" class="footer-link">
                <i class="fa fa-envelope me-2"></i>
                {{ 'FOOTER.CONTACT_US' | translate }}
              </a>
            </li>
            <li class="mb-2">
              <a href="https://www.livingwd.org/lwcc-policy/"  target="_blank" class="footer-link">
                <i class="fa fa-shield-alt me-2"></i>
                {{ 'FOOTER.PRIVACY_POLICY' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Partner Organizations Section -->
      <div class="col-lg-3 col-md-6">
        <div class="footer-section">
          <h4 class="text-uppercase fw-bold mb-4 text-light">
            {{ 'FOOTER.LINKS_TITLE' | translate }}
            <!-- <i class="fa fa-handshake me-2"></i> -->
          </h4>
          <ul class="list-unstyled footer-links">
            <li class="mb-2">
              <a href="https://www.livingwd.org/" 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 class="footer-link">
                <i class="fa fa-church me-2"></i>
                {{ 'FOOTER.LIVING_WORD_CENTER' | translate }}
                <i class="fa fa-external-link ms-1 small"></i>
              </a>
            </li>
            <li class="mb-2">
              <a [href]="'FOOTER.FOUNDATIONS_ONLINE_URL' | translate"
                 target="_blank" 
                 rel="noopener noreferrer" 
                 class="footer-link">
                <i class="fa fa-laptop me-2"></i>
                {{ 'FOOTER.FOUNDATIONS_ONLINE' | translate }}
                <i class="fa fa-external-link ms-1 small"></i>
              </a>
            </li>
            <li class="mb-2">
              <a href="https://lwsom.org/" 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 class="footer-link">
                <i class="fa fa-graduation-cap me-2"></i>
                {{ 'FOOTER.BIBLE_TRAINING_CENTER' | translate }}
                <i class="fa fa-external-link ms-1 small"></i>
              </a>
            </li>
            <li class="mb-2">
              <a [href]="'FOOTER.JBS_URL' | translate"
                 target="_blank" 
                 rel="noopener noreferrer" 
                 class="footer-link">
                <i class="fa fa-briefcase me-2"></i>
                {{ 'FOOTER.JOSEPH_BUSINESS_SCHOOL' | translate }}
                <i class="fa fa-external-link ms-1 small"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Contact & Social Section -->
      <div class="col-lg-3 col-md-6">
        <div class="footer-section">
          <h4 class="text-uppercase fw-bold mb-4 text-light">
            <!-- <i class="fa fa-address-card me-2"></i> -->
            {{ 'FOOTER.CONNECT_WITH_US' | translate }}
          </h4>

          <!-- Contact Info -->
          <div class="footer-contact mb-4">
            <h4 class="mb-2 small">
              <!-- <i class="fa fa-map-marker-alt me-2 text-warning"></i> -->
              Living Word Christian Center
            </h4>
            <p class="mb-2 small">
              <i class="fa fa-phone me-2 text-warning"></i>
              <a href="tel:+17086975000" class="footer-link">
                (708) 697-5000
              </a>
            </p>
            <p class="mb-3 small">
              <i class="fa fa-envelope me-2 text-warning"></i>
              <a href="mailto:info&#64;livingwd.org" class="footer-link">
                info&#64;livingwd.org
              </a>
            </p>
          </div>

          <!-- Social Media -->
          <div class="footer-social">
            <h4 class="small fw-bold mb-3">{{ 'FOOTER.FOLLOW_US' | translate }}</h4>
            <div class="d-flex gap-3">
              <a href="https://www.facebook.com/livingwd" target="_blank" class="footer-social-link" aria-label="Facebook">
                <i class="fa fa-facebook-f"></i>
              </a>
              <a href="https://www.youtube.com/@livingwd" target="_blank" class="footer-social-link" aria-label="YouTube">
                <i class="fa fa-youtube"></i>
              </a>
              <a href="http://instagram.com/livingwd" target="_blank" class="footer-social-link" aria-label="Instagram">
                <i class="fa fa-instagram"></i>
              </a>
              <a href="https://twitter.com/intent/follow?source=followbutton&amp;variant=1.0&amp;screen_name=livingwd" target="_blank" class="footer-social-link" aria-label="Twitter">
                <i class="fa fa-twitter"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <!-- Footer Bottom / Copyright -->
  <div class="footer-bottom">
    <div class="container">
      <div class="row align-items-center py-3">
        <div class="col-md-6">
          <p class="mb-0 small">
            © {{ this.year }} {{ 'FOOTER.COPYRIGHT' | translate }}
            <a href="https://www.livingwd.org" 
               target="_blank" 
               rel="noopener noreferrer" 
               class="footer-link ms-1">
              {{ 'FOOTER.LIVING_WORD_CENTER' | translate }}
            </a>
          </p>
        </div>
        <div class="col-md-6 text-md-end">
          <!-- <p class="mb-0 small text-white-50">
            Made with 
            <i class="fa fa-heart text-danger mx-1"></i> 
            for ministry
          </p> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Back to Top Button -->
  <button *ngIf="showScrollToTop"
          class="btn btn-warning position-fixed bottom-0 end-0 m-4 rounded-circle footer-back-to-top"
          (click)="scrollToTop()"
          aria-label="Back to top"
          style="width: 50px; height: 50px; z-index: 1000;">
    <i class="fa fa-arrow-up"></i>
  </button>
  
</footer>
